import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M10.343 15.857a3.899 3.899 0 1 1 5.513-5.514 3.899 3.899 0 0 1-5.513 5.514Zm1.414-4.1a1.899 1.899 0 1 0 2.685 2.685 1.899 1.899 0 0 0-2.685-2.685Zm12.065 3.007-6.51 6.51-1.27-1.27-1.415 1.414 1.27 1.27-1.794 1.795 1.414 1.414 1.795-1.794 3.315 3.315 1.415-1.414-3.316-3.316.774-.774 1.877 1.877a4.057 4.057 0 1 0 5.738-5.738l-3.291-3.29h-.002Zm-1.03 7.613L20.913 20.5l2.91-2.91 1.877 1.877a2.057 2.057 0 0 1-2.91 2.91Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M5 5h16.414L34.88 18.465a5 5 0 0 1 0 7.07l-9.89 9.89a5 5 0 0 1-7.012.057L5 22.924V5Zm2 2v15.076l12.368 11.969a3 3 0 0 0 4.207-.035l9.89-9.889a3 3 0 0 0 0-4.242L20.584 7H7Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const PictogramValuationPrice40 = createIcon(IconComponent);